import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa55d562"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loginPopup" }
const _hoisted_2 = { class: "loginPopup__holder" }
const _hoisted_3 = { class: "loginChoose__holder" }
const _hoisted_4 = { class: "top-bar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"font-weight":"bold"} }, "Wallet", -1 /* HOISTED */))
const _hoisted_6 = { class: "loginChoose__body" }
const _hoisted_7 = { class: "loginChoose__description" }
const _hoisted_8 = {
  class: "container",
  style: {"width":"100%","height":"100px","box-shadow":"0px 0px 24px 0px rgba(196, 203, 212, 1)","border-radius":"20px 20px 20px 20px"}
}
const _hoisted_9 = {
  class: "logo",
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "address" }
const _hoisted_12 = { class: "copy" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "disconnect" }
const _hoisted_15 = { style: {"width":"100%","padding-top":"40px"} }
const _hoisted_16 = { style: {"display":"flex","width":"100%","align-items":"center","justify-content":"space-between"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Connected to:", -1 /* HOISTED */))
const _hoisted_18 = { class: "net-changer" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-aa55d562><circle opacity=\"0.2\" cx=\"13\" cy=\"13\" r=\"6\" fill=\"#088201\" data-v-aa55d562><animate attributeName=\"r\" values=\"6;9;6\" dur=\"2s\" repeatCount=\"indefinite\" data-v-aa55d562></animate></circle><circle cx=\"13\" cy=\"13\" r=\"3\" fill=\"#088201\" data-v-aa55d562><animate attributeName=\"r\" values=\"1;4;1\" dur=\"2s\" repeatCount=\"indefinite\" data-v-aa55d562></animate></circle></svg>", 1)
const _hoisted_20 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "loginPopup__background",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Button, {
            icon: "pi pi-times",
            style: {"margin-bottom":"0.5rem"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
            class: "p-button-rounded p-button-secondary p-button-text"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  style: {"width":"50px","height":"50px"},
                  src: $setup.logo
                }, null, 8 /* PROPS */, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, _toDisplayString($setup.addDotsInsideTooLongString($setup.useUserStore().getAccount.address, 35)), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", { onClick: $setup.copyTxt }, "copy"),
                _createTextVNode("    "),
                _createElementVNode("a", {
                  href: `${$setup.useConfigurationStore().config.explorerAccount}${$setup.useUserStore().getAccount.address}`,
                  target: "_blank"
                }, _toDisplayString(_ctx.$t('CONNECT.VIEW_EXPLORER')), 9 /* TEXT, PROPS */, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Button, {
                  class: "secondary",
                  onClick: $setup.logout
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('COMMON.DISCONNECT')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("span", null, [
                  _createElementVNode("span", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("select", {
                      class: "currentBlockchain__selector",
                      onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.onChange($event)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.configMap, ([key, item]) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: key,
                          value: key,
                          selected: $setup.curentNetwork === item.networkName
                        }, _toDisplayString(item.networkName), 9 /* TEXT, PROPS */, _hoisted_20))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 32 /* NEED_HYDRATION */)
                  ])
                ])
              ])
            ]),
            _createCommentVNode("            <div style=\"display: flex; align-items: center; justify-content: space-evenly; flex-direction: column;\">"),
            _createCommentVNode("              <div style=\"display: flex\">"),
            _createCommentVNode("                  <span v-if=\"showKeplrLogo\">"),
            _createCommentVNode("                    <KeplrLogo style=\"display: flex; background-color: #002C50; color: white; font-size: 2em; padding: 0 10px\" />"),
            _createCommentVNode("                  </span>"),
            _createCommentVNode("                <div class=\"loginChoose__descriptionIcon\" v-if=\"!showKeplrLogo\">"),
            _createCommentVNode("                  <img  :src=\"logo\">"),
            _createCommentVNode("                </div>"),
            _createCommentVNode("                <div class=\"loginPopup__addressHolder\">"),
            _createCommentVNode("                  <p>{{useUserStore().getAccount.address}}</p>"),
            _createCommentVNode("                  <Icon name=\"Copy\" @click=\"copyTxt\">{{$t('COPY.ADDRESS')}}</Icon>"),
            _createCommentVNode("                </div>"),
            _createCommentVNode("              </div>"),
            _createCommentVNode("                <span style=\"display: flex;width: 100%;align-items: center;justify-content: space-between;\">"),
            _createCommentVNode("                  <span>Connected to:</span>"),
            _createCommentVNode("                  <span>"),
            _createCommentVNode("                    <span class=\"net-changer\">"),
            _createCommentVNode("                      <svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">"),
            _createCommentVNode("                        <circle opacity=\"0.2\" cx=\"13\" cy=\"13\" r=\"6\" fill=\"#088201\">"),
            _createCommentVNode("                          <animate attributeName=\"r\" values=\"6;9;6\" dur=\"2s\" repeatCount=\"indefinite\" />"),
            _createCommentVNode("                        </circle>"),
            _createCommentVNode("                        <circle cx=\"13\" cy=\"13\" r=\"3\" fill=\"#088201\">"),
            _createCommentVNode("                          <animate attributeName=\"r\" values=\"1;4;1\" dur=\"2s\" repeatCount=\"indefinite\" />"),
            _createCommentVNode("                        </circle>"),
            _createCommentVNode("                      </svg>"),
            _createCommentVNode("                      <select class=\"currentBlockchain__selector\" @change=\"onChange($event)\">"),
            _createCommentVNode("                        <option v-for=\"[key, item] in configMap\" :key=\"key\" :value=\"key\" :selected= \"curentNetwork === item.networkName\">{{ item.networkName }}</option>"),
            _createCommentVNode("                      </select>"),
            _createCommentVNode("                    </span>"),
            _createCommentVNode("                  </span>"),
            _createCommentVNode("                </span>"),
            _createCommentVNode("               <a :href=\"`${useConfigurationStore().config.explorerAccount}${useUserStore().getAccount.address}`\""),
            _createCommentVNode("                target=\"_blank\" class=\"loginPopup__disconnect p-button\">{{ $t('CONNECT.VIEW_EXPLORER')}}</a>"),
            _createCommentVNode("               <Button class=\"loginPopup__disconnect\" @click=\"logout\">{{ $t('COMMON.DISCONNECT') }}</Button>"),
            _createCommentVNode("              &lt;!&ndash;<div class=\"loginPopup__data\" style=\"display: flex; flex-direction: column; justify-items: left\">"),
            _createCommentVNode("                <p>{{ useUserStore().getAccount.address.slice(0, 13)}}...{{useUserStore().getAccount.address.slice(-6)}}</p>"),
            _createCommentVNode("                <div>"),
            _createCommentVNode("                  <Button @click=\"copyTxt\" style=\"width: 30%\">copy</Button>"),
            _createCommentVNode("                  <a :href=\"`https://explorer-testnet.chain4energy.org/accounts/${useUserStore().getAccount.address}`\""),
            _createCommentVNode("                     target=\"_blank\">{{ $t('CONNECT.VIEW_EXPLORER')}}</a>"),
            _createCommentVNode("                </div>"),
            _createCommentVNode("              </div>&ndash;&gt;"),
            _createCommentVNode("            </div>")
          ])
        ])
      ])
    ])
  ]))
}